/**
 * @file Converts a dollar amount to its equivalent whole-number cent value.
 */
import Big from "big.js";

const CENTS_IN_DOLLAR = 100;

/**
 * Converts a dollar amount to cents, or 0 for an empty value.
 */
const getAmountWithoutCents = (value: string | number): number => {
  const isEmpty = value === "";

  if (isEmpty) {
    return 0;
  }

  const big = new Big(value).times(CENTS_IN_DOLLAR);
  const amount = big.toNumber();

  return amount;
};

export default getAmountWithoutCents;
